(function () {
  function initSearchDrawerClear() {
    const clearButton = document.getElementById('input_clear_button');
    const searchInput = document.querySelector('#Search-Drawer .search-field');

    if (!clearButton || !searchInput) {
      return;
    }

    clearButton.addEventListener('click', function () {
      searchInput.value = '';
      searchInput.focus();

      // Let any predictive-search / other listeners know the field changed
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchDrawerClear);
  } else {
    initSearchDrawerClear();
  }
})();
